// extracted by mini-css-extract-plugin
export default {"deliveryData":"deliveryOrdersDataList_deliveryData__E1GJy"};